// extracted by mini-css-extract-plugin
export default {"ellipsisTextComp":"index_ellipsisTextComp__ooQHp","multilineEllipsisTextComp":"index_multilineEllipsisTextComp__5FfPw"};